var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sta-table-1"},[_c('CTable',{staticClass:"table-queue",attrs:{"head":_vm.head,"body":_vm.longQueue},scopedSlots:_vm._u([{key:"class1_class3",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(_vm._s(data.class1)+" - "+_vm._s(data.class3))])]}},{key:"period",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(_vm._s(data.period)+"期")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40fe881d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_statistics/sta-table/sta_table1.vue
// module id = null
// module chunks = 